module.exports = __webpack_public_path__ + "img/heading-line.7d378ae5.svg";